import { Injectable } from '@angular/core';
import {
  BasketSearchSortDirection,
  BasketSearchSortType,
} from 'graphql-api/baskets-api-interfaces';
import { map } from 'rxjs/operators';

import { SearchBasketsByOrderRefGQL } from '../queries/search-baskets-by-order-ref.gql';
import { SearchUserBasketsGQL } from '../queries/search-user-baskets.gql';

@Injectable()
export class SearchBasketsService {
  constructor(
    private searchUserBasketsGQL: SearchUserBasketsGQL,
    private searchBasketsGQL: SearchBasketsByOrderRefGQL,
  ) {}

  public searchBaskets(
    refNumber?: string,
    page?: number,
    resultCount?: number,
  ) {
    return this.searchBasketsGQL
      .fetch({
        start: page,
        num: resultCount,
        sortBy: BasketSearchSortType.LastUpdatedTime,
        sortDirection: BasketSearchSortDirection.Desc,
        orderReferenceNumber: refNumber || undefined,
      })
      .pipe(map(({ data }) => data.searchBaskets));
  }

  public searchUserBaskets(
    refNumber?: string,
    page?: number,
    resultCount?: number,
    basketsAmount?: number,
  ) {
    return this.searchUserBasketsGQL
      .fetch({
        orderReferenceNumber: refNumber,
        start: page,
        num: resultCount,
        basketsAmount,
      })
      .pipe(map((response) => response.data.searchUserBaskets));
  }
}
